import { useParams } from 'react-router-dom';
import { AssetForm } from '~/components/assets/AssetForm';

export default function SiteAssetNew() {
  const { siteId } = useParams();

  return (
    <div className='h-full overflow-hidden'>
      <AssetForm />
    </div>
  );
}
